import * as React from 'react';

import Loader from 'bundles/degree-home/components/Loader';
import SummaryCourseItem from 'bundles/degree-home/components/SummaryCourseItem';
import type { NormalizedPassedCourse } from 'bundles/degree-home/components/v2/types/courseStates';

import _t from 'i18n!nls/degree-home';

import { SummaryCard } from './SummaryCard';

type Props = {
  loading: boolean;
  passedCourses?: Array<NormalizedPassedCourse>;
};

export const EndedCourses = ({ loading, passedCourses }: Props) => (
  <SummaryCard title={_t('Ended')}>
    {loading && <Loader />}
    {!loading &&
      passedCourses?.map((passedCourse) => (
        <SummaryCourseItem
          key={passedCourse.id}
          courseId={passedCourse.id}
          courseName={passedCourse.name}
          courseSlug={passedCourse.slug}
          statusText={_t('Ended')}
          isCourseEnrollable={false}
        />
      ))}
  </SummaryCard>
);

export default EndedCourses;
